module.exports = __webpack_public_path__ + "img/mongodb.c3d5f6e1.png";